import { useEffect, useState } from 'react';
import { Form, Input, Modal, Radio } from 'antd';
import {
  CarOutlined,
  HomeOutlined,
  LockOutlined,
  MailOutlined,
  MobileOutlined,
  UserAddOutlined,
  UserOutlined,
} from '@ant-design/icons';
import {} from 'firebase/firestore';
import PropTypes from 'prop-types';
import {
  accessLevels,
  formItemLayout,
  modalWidth,
  userInfoLimits,
} from '../common/constants';
import debugLog from '../common/debugLog';
// remember to use siteId @@@@@@@@@@@@@@@@@
export default function AddResidentModal({
  // message,
  // reload,
  showForm,
  siteName,
  visible,
}) {
  const [enabled, setEnabled] = useState(false);
  const [loading, setLoading] = useState(false);

  const [form] = Form.useForm();

  // destructure imports
  const { owner, resident, tenant } = accessLevels;
  const { colSpanLabel, colSpanWrapper } = formItemLayout;
  const { extend, normal } = modalWidth;
  const {
    contactNumberLength,
    fullnameLengthMax,
    fullnameLengthMin,
    validateDebounce,
  } = userInfoLimits;

  const handleModalReset = () => {
    setEnabled(false);
    setLoading(false);
    showForm(false);
  };

  const handleCancel = () => {
    form.resetFields();
    handleModalReset();
    debugLog('-- User cancelled the modal');
  };

  const handleSubmit = (values) => {
    // setLoading(true);
    // WIP scaffold: form submit not yet wired to backend.  debugLog shows
    // what would be POSTed so the dev can verify the form payload; goes
    // through the dev-only wrapper instead of raw console.log.
    debugLog('-- AddResident form submit:', values);
  };

  const watchedValues = Form.useWatch([], form); // watch all values

  useEffect(() => {
    form
      .validateFields({ validateOnly: true })
      .then(() => setEnabled(true))
      .catch(() => setEnabled(false));
  }, [form, watchedValues]);

  return (
    <Modal
      confirmLoading={loading}
      destroyOnHidden
      okButtonProps={{ disabled: !enabled, icon: <UserAddOutlined />, loading }}
      okText="Add Resident"
      onCancel={handleCancel}
      onOk={form.submit}
      open={visible}
      title={`Add New Resident (${siteName})`}
      width={{
        xs: '75%',
        sm: '75%',
        md: normal,
        lg: normal,
        xl: '48%',
        xxl: extend,
      }}
    >
      <Form
        colon={false}
        form={form}
        id="addResident"
        labelCol={{ span: colSpanLabel - 1 }}
        labelWrap
        name="addResident"
        onFinish={handleSubmit}
        variant="outlined"
        wrapperCol={{ span: colSpanWrapper - 2 }}
      >
        <Form.Item
          hasFeedback
          label="Fullname"
          name="fullname"
          rules={[
            {
              max: fullnameLengthMax,
              message: `Fullname is required (${fullnameLengthMin}-${fullnameLengthMax} characters)`,
              min: fullnameLengthMin,
              required: true,
            },
          ]}
          validateDebounce={validateDebounce}
        >
          <Input
            addonBefore={<UserOutlined />}
            autoComplete="fullname"
            allowClear
            placeholder="fullname"
          />
        </Form.Item>
        <Form.Item
          hasFeedback
          label="Contact"
          name="contactNumber"
          rules={[
            {
              max: contactNumberLength,
              message: 'phone',
              min: contactNumberLength,
              pattern: /^[689]\d{7}$/gi,
              required: true,
            },
          ]}
          validateDebounce={validateDebounce}
        >
          <Input
            addonBefore={<MobileOutlined />}
            allowClear
            autoComplete="phone"
            placeholder="local only"
            prefix="+65"
          />
        </Form.Item>
        <Form.Item
          hasFeedback
          label="Email"
          name="email"
          rules={[{ required: true, type: 'email' }]}
          validateDebounce={validateDebounce}
        >
          <Input
            addonBefore={<MailOutlined />}
            allowClear
            autoComplete="email"
            placeholder="email"
          />
        </Form.Item>
        <Form.Item
          hasFeedback
          initialValue={resident}
          label="Account"
          name="accessLevel"
          rules={[{ required: true }]}
        >
          <Radio.Group
            buttonStyle="solid"
            id="radioGroup"
            name="accessLevel"
            onChange={(e) => debugLog('-- Selected:', e.target.value)}
            options={[
              { label: 'Resident', value: resident },
              { label: 'Owner', value: owner },
              { label: 'Tenant', value: tenant },
            ]}
            optionType="button"
          />
        </Form.Item>
        <Form.Item
          hasFeedback
          label="Block"
          name="blockNumber"
          rules={[{ required: true }]}
          validateDebounce={validateDebounce}
        >
          <Input
            addonBefore={<HomeOutlined />}
            allowClear
            placeholder="block number"
          />
        </Form.Item>
        <Form.Item
          hasFeedback
          label="Unit"
          name="unitNumber"
          rules={[{ required: true }]}
          validateDebounce={validateDebounce}
        >
          <Input
            addonBefore={<LockOutlined />}
            allowClear
            placeholder="unit number"
          />
        </Form.Item>
        <Form.Item
          hasFeedback
          label="Vehicle Number"
          name="vehicleNumber"
          rules={[{ required: true }]}
          validateDebounce={validateDebounce}
        >
          <Input
            addonBefore={<CarOutlined />}
            allowClear
            placeholder="vehicle number"
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}

AddResidentModal.propTypes = {
  showForm: PropTypes.func.isRequired,
  siteName: PropTypes.string.isRequired,
  visible: PropTypes.bool.isRequired,
};
